<template>
  <div class="iv-difficult-declare iv-p-t-24">
    <div class="iv-main-width">
      <div class="iv-text-right iv-diff-add iv-p-b-8">
        <Button type="add" @click="addMember">困难申请</Button>
      </div>
      <List 
        v-if="list.length > 0" 
        type="difficult" 
        :list="list"
        :showPage="true"
        :current="currentPage" 
        :total="total" 
        @on-detail="detailPage"
        @on-page-size-change="changePageSize"
        @on-change="changePage"
      ></List>
      <NoData v-if="list.length <= 0"></NoData>
    </div>
  </div>
</template>

<script>
import NoData from '@/components/no-data'
import List from '@/components/declare-list'
import { deletePoor } from './interface/index.js'

export default {
  data () {
    return {
      total: 0,
      list: [],
      currentPage: 1,
      pageSize: 5
    }
  },
  created () {
    this.currentPage = Number(this.$route.query.currentPage) || 1
    this.getDifficultList()
  },
  methods: {
    //获取困难列表
    getDifficultList () {
      this.$ajax({
        url: 'api-general/module/portal/poorList',
        method: 'get',
        data: {
          applyType: '01',
          currentPage: this.currentPage,
          pageSize: this.pageSize
        }
      }).then(({data}) => {
        this.list = data.data
        this.total = data.count
      })
    },
    //新增
    addMember () {
      this.$router.push({
        name: 'difficultApply',
        query: {
          type: this.$encode('add')
        }
      })
    },
    //查看  编辑
    detailPage (item, type) {
      if (type == 'delete') {
        deletePoor({
          yearPoorId: item.yearPoorId
        }).then(data => {
          if (data.code == 0) {
            this.$Message.success('删除成功')
            location.reload()
          }
        })
      } else {
        let name = 'difficultApply'
        if (type == 'help') {
          name = 'helpList'
        }
        this.$router.push({
          name: name,
          query: {
            yearPoorId: this.$encode(item.yearPoorId),
            type: this.$encode(item.reportStatus == 1 ? 'see' : 'edit'),
            currentPage: this.currentPage
          }
        })
      }
    },
    changePage (page) {
      this.currentPage = page
      this.getDifficultList()
    },
    changePageSize (page) {
      this.pageSize = page
      this.getDifficultList()
    }
  },
  components: {
    List,
    NoData
  }
}
</script>

<style lang="scss" scoped>
.iv-difficult-declare {
  min-height: 100%;;
  background-color: #fff;
  .iv-diff-add {
    border-bottom: 1px dashed rgba(#000000, 0.15);
  }
}
</style>
